import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FileInputComponent, ModalComponent} from "@app/shared/components";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-tool-ticket-report-modal',
  templateUrl: './tool-ticket-report-modal.component.html',
  styleUrls: ['./tool-ticket-report-modal.component.scss']
})
export class ToolTicketReportModalComponent implements OnInit {

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @ViewChild(FileInputComponent, {static: true}) fileInput: FileInputComponent;

    @Output() confirmEvent = new EventEmitter<any>();

    reportForm: UntypedFormGroup;

    showValidations = false;

    focused = true;
    isConfirmationInProgress = false;

    constructor() {
    }

    ngOnInit() {
        this.reportForm = new UntypedFormGroup({
            description: new UntypedFormControl('', Validators.required),
            selectedFiles: new UntypedFormControl([], Validators.required),
            affectsProduction: new UntypedFormControl(false),
            criticalDeviation: new UntypedFormControl(false),
            neededBackDate: new UntypedFormControl(null, Validators.required)
        });
    }

    open() {
        this.reset();
        this.modal.open();
    }

    close() {
        this.reset();
        this.modal.close();
        this.isConfirmationInProgress = false;
    }

    onCancel() {
        this.close();
    }

    onConfirm(event) {
        if (this.reportForm.invalid) {
            this.showValidations = true;
            this.reportForm.markAllAsTouched();
            return;
        }

        this.isConfirmationInProgress = true;
        this.confirmEvent.emit({
            description: this.reportForm.value.description,
            selectedFiles: this.reportForm.value.selectedFiles,
            affectsProduction: this.reportForm.value.affectsProduction,
            criticalDeviation: this.reportForm.value.criticalDeviation,
            neededBackDate: this.reportForm.value.neededBackDate
        });
    }

    private reset() {
        this.showValidations = false;
        this.reportForm.reset();
        this.fileInput.fileInput.files = [];
    }

    selectFiles($event) {
        this.reportForm.controls['selectedFiles'].setValue($event);
    }
}
